import React, { ReactEventHandler } from 'react';
import styled, { css, CSSProperties } from 'styled-components';
import RadioBase from '../RadioStyle';

export const RadioGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const shapeMap = {
  box: css`
    padding: 12px;
  `,
  default: css`
    padding: 4px 0;
    border: none;
  `,
};

const WrapLabel = styled.label<{
  isChecked?: boolean;
  shape?: 'box' | 'default';
  align?: 'left' | 'center' | 'right';
}>`


  display: grid;
  grid-template-columns: 32px auto;
  align-items: center;
  justify-content: ${({ align }) => {
    if (align === 'center') return 'center';
    if (align === 'right') return 'flex-end';
    return 'flex-start';
  }};
  border: 1px solid
    ${({ isChecked, shape }) =>
    shape === 'box'
      ? isChecked
        ? 'var(--primaryColor)'
        : 'var(--lineColor)'
      : 0};
  ${({ shape }) => shape && shapeMap[shape]};
  border-radius: var(--cardBorderRadius);
  &:hover {
    cursor: var(--hoverCursorURL), pointer;
  }
`;

const CustomLabel = styled.span<{
  grid?: number;
}>`
  width: 100%;
  display: grid;
  word-break: keep-all;

  ${({ grid }) => {
    if (grid === 2) {
      return css`
        grid-template-columns: 1fr 4fr;
        grid-gap: 12px;
        align-items: center;
      `;
    }
    if (grid === 3) {
      return css`
        grid-template-columns: 1fr 2fr 2fr;
        grid-gap: 12px;
        align-items: center;
      `;
    }
  }}
`;

interface RadioBoxProps {
  value: string;
  onChange: ReactEventHandler | undefined;
  checked?: boolean;
  name: string;
  id?: string;
  children?: any | undefined;
  defaultChecked?: boolean;
  disabled?: boolean;
  grid?: number;
  shape?: 'box' | 'default';
  style?: CSSProperties;
  align?: 'left' | 'center' | 'right'; // 🆕 정렬 옵션
}

function RadioBox(props: RadioBoxProps) {
  const {
    checked,
    name,
    disabled,
    value,
    id = value,
    onChange,
    defaultChecked,
    children,
    grid = 1,
    shape = 'box',
    style,
    align = 'left',
  } = props;

  return (
    <>
      <WrapLabel
        htmlFor={id}
        isChecked={checked}
        shape={shape}
        onClick={onChange}
        style={style}
        align={align}
      >
        <RadioBase
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          checked={checked}
          defaultChecked={defaultChecked}
          disabled={disabled}
        />
        <CustomLabel grid={grid}>{children}</CustomLabel>
      </WrapLabel>
    </>
  );
}

export default RadioBox;
